import { render, staticRenderFns } from "./ConfirmaDadosInscricaoEleitoral.vue?vue&type=template&id=20513fe0&scoped=true"
import script from "./ConfirmaDadosInscricaoEleitoral.vue?vue&type=script&lang=js"
export * from "./ConfirmaDadosInscricaoEleitoral.vue?vue&type=script&lang=js"
import style0 from "./ConfirmaDadosInscricaoEleitoral.vue?vue&type=style&index=0&id=20513fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20513fe0",
  null
  
)

export default component.exports